/**
 * For usage in webpackHelpers to set DEPLOY_ENV global variable
 *
 * @returns "qa | stage | production"
 */
function getDeployEnv() {
  const deployEnv = process.env.DEPLOY_ENV.toLowerCase();

  // Fix common mistakes with deploy env
  if ( deployEnv === "development" ) {
    return "qa";
  }
  if ( deployEnv === "staging" ) {
    return "stage";
  }
  if ( deployEnv === "prod" ) {
    return "production";
  }

  return deployEnv;
}

/** Global var DEPLOY_ENV set by webpackHelpers */
function getFrontendDeployEnv() {
  /* eslint-disable no-undef */
  /* eslint no-undef: 0*/
  return DEPLOY_ENV;
}

module.exports = {
  getDeployEnv,
  getFrontendDeployEnv,
};
